import {
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  sentryDsn,
  amplitudeAPIKey,
  muiProKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "production",
  appRegion: "com",
  appEnv: "com-production",
  displayAppEnv: "Production INTL",
  urls: {
    apiUrl: "https://core.api.holobuilder.com",
    baseUrl: "https://admin.holobuilder.com",
    dashboardUrl: "https://sphere.holobuilder.com",
    webEditorUrl: "https://app.holobuilder.com/app",
    entryPageUrl: "https://entry.holobuilder.com",
    adminPanelApi: "https://admin.holobuilder.com/api",
    cookieManagerUrl:
      "https://cookies.holobuilder.com/cookie-manager/manager/latest",
  },
  features: {
    muiProKey,
    amplitudeAPIKey,
  },
  keys: {
    sentryDsn,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support@holobuilder.com",
  isNumberedEnv: false,
  numberedEnv: null,
};
